import React from 'react'

function Person({name, img, bio}) {
    return (
        <div className="person">
            <img src={img} alt={name}/>
            <div>
                <header>
                    <h4>{name}</h4>
                </header>
                
                
                <p>{bio}</p>
            </div>
        </div>
    )
}

export default Person
